export function OutlineProveedor1Icon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0168 1.99414V4.99444"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M16.0161 8.99789C16.0161 11.2061 14.2255 12.9967 12.0125 12.9967C9.79945 12.9967 8.01367 11.2061 8.01367 8.99789C8.01367 8.26822 8.21049 7.58655 8.54652 6.99609C9.03617 7.30332 10.2795 7.99459 12.0077 7.99459C13.7454 7.99459 14.9936 7.30332 15.4832 6.99609C15.6464 7.28412 16.0161 7.74017 16.0161 8.99789Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.01165 15.998H18.0176C19.1218 15.998 20.0146 16.8909 20.0146 17.995V21.0001H4.01465V17.995C4.01465 16.8909 4.90754 15.998 6.01165 15.998Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0161 6.99685C15.3488 7.35208 13.9231 8.00015 12.0077 7.99535C10.1019 7.99535 8.68094 7.35208 8.01367 6.99685C8.01367 6.69922 8.04728 6.26237 8.20569 5.76312C8.40251 5.15346 8.74335 4.61101 9.18499 4.16936C9.90986 3.44449 10.9084 2.99805 12.0125 2.99805C13.1166 2.99805 14.1199 3.44449 14.8448 4.16936C15.5696 4.89424 16.0161 5.89274 16.0161 6.99685Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0146 6.99609H16.0161"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.01364 6.99609H7.01514"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.01636 15.998V20.9953"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M16.0161 15.998V20.9953"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
